export default __webpack_public_path__ + "static/media/economics-bg.8ed05577.webp";